'use client';

import { useEffect, useState } from 'react';

let cache: { isAdmin: boolean } | null = null;
let inflight: Promise<boolean> | null = null;

export function clearAdminModeCache() {
  cache = null;
  inflight = null;
}

function fetchAdminStatus(): Promise<boolean> {
  if (cache !== null) return Promise.resolve(cache.isAdmin);
  if (!inflight) {
    inflight = fetch('/api/admin/auth/check', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : { authenticated: false }))
      .then((d: { authenticated?: boolean }) => {
        cache = { isAdmin: !!d.authenticated };
        return cache.isAdmin;
      })
      .catch(() => {
        cache = { isAdmin: false };
        return false;
      });
  }
  return inflight;
}

export function useAdminMode() {
  const [isAdmin, setIsAdmin] = useState<boolean>(cache?.isAdmin ?? false);
  const [loading, setLoading] = useState<boolean>(cache === null);

  useEffect(() => {
    if (cache !== null) return;
    let cancelled = false;
    fetchAdminStatus().then((v) => {
      if (cancelled) return;
      setIsAdmin(v);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { isAdmin, loading };
}
